import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { Box, Paper } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getCurrentLanguage } from 'src/Libs/languages/functions/default'

const INVERTER_TOOL_IFRAME_ID = 'inverter-tool-iframe'
const INVERTER_TOOL_LINK_WITHOUT_LANGUAGE = 'https://s10.e3dc.com/E3dcWeb/auslegung/?LANG='
const DEFAULT_LANGUAGE = 'DE'

/**
 * Wrapper Component for InverterTool that comes from s10 Portal within an iframe
 */
const InverterTool: React.FC = () => {
  const { t } = useCustomTranslation()
  const dispatch = useDispatch()
  const lang = getCurrentLanguage()
  const [link, setLink] = useState<string>(INVERTER_TOOL_LINK_WITHOUT_LANGUAGE + (lang ?? DEFAULT_LANGUAGE))

  useEffect(() => {
    if (lang === 'de' || lang === 'en') {
      setLink(INVERTER_TOOL_LINK_WITHOUT_LANGUAGE + lang.toUpperCase())
    }
  }, [lang])

  useEffect(() => {
    dispatch(appUpdate({ title: t('framework.inverter-tool') }))
  }, [dispatch, t])

  return (
    <Paper sx={{ height: '100%', p: 2 }}>
      <Box
        id={INVERTER_TOOL_IFRAME_ID}
        component="iframe"
        src={link}
        sx={{ width: '100%', height: '100%', border: theme => `1px solid ${theme.palette.common.white}` }}
      />
    </Paper>
  )
}

export default InverterTool
